import { createContext } from 'react';

const ImageViewerContext = createContext(null);

export { ImageViewerContext };
